import { Injectable, signal } from '@angular/core';
import { SalesData, Receipt, StaffSale, StaffSaleDetail } from '../types/sales-inquiry';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from './authentication.service';
import { UriApi } from '../helpers/UriApi';
import { MasterService } from './master.service';

@Injectable({
  providedIn: 'root'
})
export class SalesInquiryService {
  body = {
    request: {
      jsonParams: {},
      functionCode: 109,
      data: "",
      dataList: "",
      menuCd: '',
    }
  };

  constructor(private http: HttpClient, private auth: AuthenticationService, private masterService : MasterService
  ) { }


  print(trHead: any) {
    const param = {
      trHead: trHead
    }
    return this.http.post(UriApi.api_ServicePos_Print, param)
  }

  getBill(trHead: any) {
    const param = {
      trHead: trHead
    }
    return this.http.post(UriApi.api_ServicePos_GetBillPreview, param)
  }
}